import { z } from 'zod';

import { Length } from '../fields/Length';

const { units, unit } = Length;

const validator = z.object({
    width: z.number().nullable().default(null),
    length: z.number().nullable().default(null),
    height: z.number().nullable().default(null),
    unit,
});

export const Dimensions = {
    validator,
    units,
};
